export const TIER_FEATURES = {
  free: [
    'basic_chat',
    'basic_analytics',
    'default_alerts',
  ],
  ifpa: [
    'basic_chat',
    'basic_analytics',
    'advanced_analytics',
    'default_alerts',
    'custom_alerts',
    'webapp_access',
  ],
  basic: [
    'basic_chat',
    'basic_analytics',
    'default_alerts',
    'custom_alerts',
  ],
  advanced: [
    'basic_chat',
    'basic_analytics',
    'advanced_analytics',
    'default_alerts',
    'custom_alerts',
    'webapp_access',
  ],
  elite: [
    'basic_chat',
    'basic_analytics',
    'advanced_analytics',
    'default_alerts',
    'custom_alerts',
    'webapp_access',
  ],
};

export const hasFeature = (tier, feature) => {
  const features = TIER_FEATURES[tier] || TIER_FEATURES.free;
  return features.includes(feature);
};

export const isPremiumTier = (tier) => {
  return tier !== 'free' && tier !== 'ifpa';
};

export const isTrialTier = (tier) => {
  return tier === 'ifpa';
};
